import axios from "axios"
import _get from "lodash/get"
import _head from "lodash/head"
import _size from "lodash/size"
import _filter from "lodash/filter"
import _replace from "lodash/replace"
import { firebaseAuth } from "../firebaseConfig"
import moment from "moment"

export const API_BASE_URL =
  "https://us-central1-gofloaters.cloudfunctions.net/api"
// export const API_BASE_URL = "http://localhost:5001/gofloaters/us-central1/api"

const API_PATHS = {
  CHECK_BOOKING_AVAILABILITY: `${API_BASE_URL}/spaces/checkavailabilities`,
  SPACE_AVAILABILITY: `${API_BASE_URL}/spaces/getAvailability`,
  // `${API_BASE_URL}//worqflexi/space/availability`
  CREATE_BOOKING: `${API_BASE_URL}/bookings/reactnative/doBooking`,
  GET_METADATA: `${API_BASE_URL}/worqflexi/meta`,
  CREATE_USER: `${API_BASE_URL}/updateuserdetails`,
  REFERRAL_VALIDATION: `${API_BASE_URL}/checkreferralcode`,
  MAKE_BOOKING: `${API_BASE_URL}/booking`,
  CREATE_RAZORPAY_ORDER: `${API_BASE_URL}/booking/{{bookingId}}/razorpay-order`,
  UPDATE_PAYMENT_STATUS: `${API_BASE_URL}/admin/updatestatus`,
  CHECK_SPACE_AVAILABILITY: `${API_BASE_URL}/worqflexi/space/availability`,
  CANCEL_BOOKING: `${API_BASE_URL}/booking/update `,
  REDEEM_BOOKING: `${API_BASE_URL}/booking/update `,
  EMAIL_INVOICE: `${API_BASE_URL}/booking/emailinvoice`,
  ADD_FEEDBACK: `${API_BASE_URL}/addfeedback`,
  APPLY_COUPON: `${API_BASE_URL}/user/voucher/discountcode`,
}

export const getSeatsAvailable = async ({
  spaceId,
  dates,
  numberOfSeats,
  duration,
}) => {
  try {
    const response = await axios.post(API_PATHS.CHECK_BOOKING_AVAILABILITY, {
      spaceId,
      dates,
      numberOfSeats,
      duration,
    })
    return (
      _get(_head(_get(response, "data")), "seatsAvailable") -
      _get(_head(_get(response, "data")), "seatsBooked")
    )
  } catch (error) {
    return {}
  }
}

export const getSeatsAvailableAPI = async ({
  spaceId,
  dates,
  numberOfSeats,
  duration,
}) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/spaces/getAvailability/?spaceId=${spaceId}&date=${dates}&numberOfSeats=${numberOfSeats}&duration=${duration}`,
    )

    return _get(response, "data")
  } catch (error) {
    return error
  }
}

export const checkBookingAvailability = async ({
  spaceId,
  dates,
  numberOfSeats,
  duration,
}) => {
  const token = await firebaseAuth.currentUser.getIdToken()
  try {
    const response = await axios.post(
      API_PATHS.CHECK_SPACE_AVAILABILITY,
      {
        spaceId,
        dates,
        numberOfSeats,
        duration,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    )
    console.log({
      data: _get(response, "data"),
      available:
        _size(
          _filter(_get(response, "data"), booking =>
            _get(booking, "availability"),
          ),
        ) === _size(dates),
    })
    return (
      _size(
        _filter(_get(response, "data"), booking =>
          _get(booking, "availability"),
        ),
      ) === _size(dates)
    )
  } catch (error) {
    return false
  }
}

export const createBooking = async bookingDetails => {
  const token = await firebaseAuth.currentUser.getIdToken()
  try {
    const response = await axios.post(API_PATHS.MAKE_BOOKING, bookingDetails, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    return _get(response, "data")
  } catch (error) {
    return {}
  }
}

// export const createUser = async userDetails => {
//   const token = await auth.currentUser.getIdToken()
//   try {
//     const response = await axios.post(API_PATHS.CREATE_USER, userDetails, {
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//     })
//     return response
//   } catch (error) {
//     return {}
//   }
// }

export const getMetaData = async () => {
  try {
    const response = await axios.get(API_PATHS.GET_METADATA, {
      headers: {
        "Content-Type": "application/json",
        apikey: "asdfkashfakfjhas8787faasdfasfdsdfgfdg",
      },
    })

    const metadata = _get(response, "data", {})
    return metadata
  } catch (e) {
    return {}
  }
}

export const createUser = async userDetails => {
  const token = await firebaseAuth.currentUser.getIdToken()
  try {
    const response = await axios.post(API_PATHS.CREATE_USER, userDetails, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    return response
  } catch (error) {
    return {}
  }
}

export const isValidReferralCode = async (referralCode, email) => {
  try {
    const response = await axios.post(
      API_PATHS.REFERRAL_VALIDATION,
      { referralCode, email },
      {
        headers: { "Content-Type": "application/json" },
      },
    )
    return response
  } catch (error) {
    return false
  }
}

export const createRazorpayOrder = async bookingId => {
  try {
    const token = await firebaseAuth.currentUser.getIdToken()
    console.log("[createRazorpayOrder] got token:", !!token)

    const url = _replace(
      API_PATHS.CREATE_RAZORPAY_ORDER,
      "{{bookingId}}",
      bookingId,
    )
    console.log("[createRazorpayOrder] posting to:", url)

    const response = await axios.post(
      url,
      {},
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    )
    console.log("[createRazorpayOrder] response status:", response?.status)
    console.log("[createRazorpayOrder] response data:", response?.data)

    const razorpayOrder = _get(response, "data.razorpayOrder")
    console.log("[createRazorpayOrder] extracted razorpayOrder:", razorpayOrder)

    return razorpayOrder
  } catch (error) {
    const status = error?.response?.status
    const data = error?.response?.data
    console.log("[createRazorpayOrder] ERROR message:", error?.message)
    console.log("[createRazorpayOrder] ERROR status:", status)
    console.log("[createRazorpayOrder] ERROR data:", data)
    const detail =
      (typeof data === "string" && data) ||
      _get(data, "message") ||
      _get(data, "error") ||
      error?.message ||
      "Unknown error"
    return { error: status ? `${status}: ${detail}` : detail }
  }
}

export const updatePaymentStatus = async ({
  paymentRefNumber,
  spaceUsageFee,
  spaceType,
  uid,
  gstFee,
  redeemedPoints,
  id,
}) => {
  const token = await firebaseAuth.currentUser.getIdToken()

  try {
    const response = await axios.post(
      API_PATHS.UPDATE_PAYMENT_STATUS,
      {
        id,
        status: "Prepaid",
        paymentRefNumber,
        bookingUsageFee: 0,
        spaceUsageFee,
        spaceType,
        gstFee,
        redeemedPoints,
        uid,
      },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    )
    return _get(response, "data.booking")
  } catch (error) {
    return {}
  }
}

export const cancelBooking = async bookingId => {
  const token = await firebaseAuth.currentUser.getIdToken()
  try {
    const response = await axios.post(
      API_PATHS.CANCEL_BOOKING,
      { id: bookingId, cancelledby: "User", status: "Cancelled" },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    )
    const data = (response && response.data) || {}
    // The API can answer 200 with { status: "failed" }; that's not a cancellation.
    if (data.status === "failed") {
      return { ok: false, message: data.message || CANCEL_FAILED }
    }
    return { ok: true, data }
  } catch (error) {
    // e.g. 400 { code: "cancellation_not_allowed", message } outside the policy
    console.log({ error })
    const data = (error && error.response && error.response.data) || {}
    const message =
      data.message ||
      (data.status === "already Cancelled"
        ? "This booking is already cancelled."
        : CANCEL_FAILED)
    return { ok: false, message }
  }
}
const CANCEL_FAILED = "We couldn't cancel this booking. Please try again."

export const emailInvoice = async bookingId => {
  const token = await firebaseAuth.currentUser.getIdToken()
  try {
    const response = await axios.post(
      API_PATHS.EMAIL_INVOICE,
      { id: bookingId, emailInvoice: true },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    )
    return response
  } catch (error) {
    console.log({ error })
    return {}
  }
}

export const redeemToConfrimBooking = async (booking, user) => {
  const token = await firebaseAuth.currentUser.getIdToken()
  try {
    const response = await axios.post(
      API_PATHS.REDEEM_BOOKING,
      {
        id: _get(booking, "bookingkey"),
        status: "Prepaid",
        paymentRefNumber: "Redeemed",
        bookingUsageFee: 0,
        spaceUsageFee: _get(booking, "spaceUsageFee"),
        spaceType: _get(booking, "spaceType"),
        gstFee: 0,
        redeemedPoints: _get(booking, "spaceUsageFee"),
        uid: _get(user, "uid"),
      },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    )
    return _get(response, "data")
  } catch (error) {
    console.log({ error })
    return {}
  }
}

export const addUserBookingFeedback = async ({
  rating,
  commentForSpaces,
  customerName,
  spaceName,
  spaceId,
  bookingId,
}) => {
  const token = await firebaseAuth.currentUser.getIdToken()
  try {
    const response = await axios.post(
      API_PATHS.ADD_FEEDBACK,
      {
        rating,
        gofloaterrating: 5,
        commentForSpaces,
        customerName,
        spaceName,
        spaceId,
        feedbackDate: moment().valueOf(),
        bookingId,
      },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    )

    return _get(response, "data.status") === "success"
  } catch (error) {
    return false
  }
}

export const applyDiscountCode = async ({ payload }) => {
  const token = await firebaseAuth.currentUser.getIdToken()

  try {
    const response = await axios.post(API_PATHS.APPLY_COUPON, payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    return response
  } catch (error) {
    return {}
  }
}
